import React from 'react';
import { motion } from 'framer-motion';
import { trackPixelEvent } from '../lib/metaPixel';
export function FinalCTA() {
  return <section className="py-16 sm:py-24 px-4" data-id="element-146">
      <motion.div className="max-w-4xl mx-auto bg-forest rounded-3xl p-8 sm:p-16 text-center shadow-xl relative overflow-hidden" initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} data-id="element-147">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-sage/20 via-transparent to-transparent pointer-events-none" data-id="element-148"></div>

        <div className="relative z-10" data-id="element-149">
          <span className="block text-[11px] font-bold uppercase tracking-widest text-sage mb-6" data-id="element-150">
            Ready to Restore the Signal
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-medium text-cream leading-tight mb-6" data-id="element-151">
            See the Full Nerva™ Science, Pricing & 60-Day Guarantee
          </h2>
          <p className="text-lg text-cream/80 mb-10 max-w-2xl mx-auto" data-id="element-152">
            One-time purchase. No subscription. 60-day money-back guarantee.
            Drug-free. 10 minutes a day. Built on 24 years of peer-reviewed
            vagal science.
          </p>

          <a href="https://rylte.com/products/nerva" target="_blank" rel="noopener noreferrer" onClick={() => trackPixelEvent('ViewContent', {
          content_name: 'Nerva',
          content_category: 'Cervical Vagal Restoration Device',
          content_ids: ['nerva'],
          content_type: 'product',
          source: 'final_cta'
        })} className="inline-flex items-center justify-center px-8 py-4 bg-cream text-forest font-medium rounded-full text-lg hover:bg-white hover:scale-105 transition-all duration-300 shadow-lg" data-id="element-153">
            Learn More About Nerva™ →
          </a>

          <p className="text-xs text-cream/50 mt-6" data-id="element-154">
            You will not be asked for a credit card to read the full product
            page.
          </p>
        </div>
      </motion.div>
    </section>;
}